var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Resize", size: "lg" },
      on: { hide: _vm.closeHandler, show: _vm.onShowHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "ButtonOutline",
                {
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.modal.hide()
                    },
                  },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _vm._v(" "),
              _c(
                "ButtonPrimary",
                {
                  attrs: { variant: "primary", disabled: _vm.isLoading },
                  on: { click: _vm.accept },
                },
                [_vm._v("\n      Resize\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            [
              _c(
                "div",
                { attrs: { role: "group" } },
                [
                  _c("label", { attrs: { for: "resize-width" } }, [
                    _vm._v("Width"),
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { id: "resize-width", type: "number" },
                    on: { input: _vm.widthChangeHandler },
                    model: {
                      value: _vm.width,
                      callback: function ($$v) {
                        _vm.width = $$v
                      },
                      expression: "width",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-3", attrs: { role: "group" } },
                [
                  _c("label", { attrs: { for: "resize-height" } }, [
                    _vm._v("Height"),
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { id: "resize-height", type: "number" },
                    on: { input: _vm.heightChangeHandler },
                    model: {
                      value: _vm.height,
                      callback: function ($$v) {
                        _vm.height = $$v
                      },
                      expression: "height",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  staticClass: "mt-3",
                  attrs: { value: true, "unchecked-value": false },
                  model: {
                    value: _vm.isMaintainAspectRatio,
                    callback: function ($$v) {
                      _vm.isMaintainAspectRatio = $$v
                    },
                    expression: "isMaintainAspectRatio",
                  },
                },
                [_vm._v("\n      Maintain aspect ratio\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  attrs: { value: true, "unchecked-value": false },
                  model: {
                    value: _vm.isCopyBeforeResize,
                    callback: function ($$v) {
                      _vm.isCopyBeforeResize = $$v
                    },
                    expression: "isCopyBeforeResize",
                  },
                },
                [_vm._v("\n      Copy before resize\n    ")]
              ),
            ],
            1
          )
        : _c("b-spinner"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }